import { render, staticRenderFns } from "./CreateScene.vue?vue&type=template&id=0fa4ae56&scoped=true&"
import script from "./CreateScene.vue?vue&type=script&lang=js&"
export * from "./CreateScene.vue?vue&type=script&lang=js&"
import style0 from "./CreateScene.vue?vue&type=style&index=0&id=0fa4ae56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa4ae56",
  null
  
)

export default component.exports